export const stringToColor = (string: string) => {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
  };

  export const stringAvatar = (name: string) => {
    const nameSplit = name?.split(" ");
    let avatar = "";
    if(!nameSplit || nameSplit.length == 0)
      avatar = ""
    else if(nameSplit.length == 1)
      avatar = `${name.split(" ")[0][0]}`
    else
      avatar = `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`;
    return {
      sx: {
        bgcolor: '#781AA0',
      },
      children: `${avatar}`,
    };
  };

